
(function () {
	'use strict';

	angular.module('hearingFeedbackModule', [])
		.controller('HearingFeedbackController', HearingFeedbackController);

	HearingFeedbackController.$inject = ['$scope', '$http', '$stateParams', '$state', '$sce', '$location', '$anchorScroll', '$timeout', '$uibModal', '$filter',
		'broadcastService', 'documentService', 'tabStateService', 'anchorService', 'documentContentsSearchService', 'resizeService', 'npDialog', 'folderService', 'configService'];

	function HearingFeedbackController($scope, $http, $stateParams, $state, $sce, $location, $anchorScroll, $timeout, $uibModal, $filter,
		broadcastService, documentService, tabStateService, anchorService, documentContentsSearchService, resizeService, npDialog, folderService, configService) {

		var vm = this;
		vm.translation = globalResources;

		vm.enableDocumentExtention = configService.getBool(HandbookConfiguration.EnableDocumentExtention);
		vm.currentData = {};
		vm.originalData = {};
		vm.isMyAssessment = false;
		vm.hearing = {};
		vm.commentDocuments = [];
		vm.preCommentDocuments = [];
		vm.preHearingMembers = [];

		vm.loginUserName = user.fullName;
		vm.loginUserId = user.userId;
		vm.responseFlag = 0;
		vm.documentTypes = E.documentTypes;

		vm.publishedVersion = configService.getBool(HandbookConfiguration.PublishedVersion);

		vm.hearingCommentAfterResponse = configService.getBool(HandbookConfiguration.HearingCommentAfterResponse);

		vm.highlights = {
			highlightText: '',
			currentIndex: 0,
			totalFound: 0
		};

		vm.userLoginPublishComment = [];
		vm.userLoginDraftComment = [];

		vm.viewModeList =
			[
				{ id: parseInt(E.documentTemplateViewMode.ProcessDependencies), name: globalResources.documentTemplateViewModeName.ProcessDependencies },
				{ id: parseInt(E.documentTemplateViewMode.Normal), name: globalResources.documentTemplateViewModeName.Normal },
				{ id: parseInt(E.documentTemplateViewMode.Process), name: globalResources.documentTemplateViewModeName.Process },
				{ id: parseInt(E.documentTemplateViewMode.RelatedDocuments), name: globalResources.documentTemplateViewModeName.RelatedDocuments },
				{ id: parseInt(E.documentTemplateViewMode.InvolvedChapters), name: globalResources.documentTemplateViewModeName.InvolvedChapters },
			];

		vm.hearings = [];
		vm.closeHearingGridSetting = [];
		vm.hearingMemberGridSetting = [];
		vm.preHearingMembersGridSetting = [];
		vm.preHearingMembersActiveGridSetting = [];
		vm.getNextSearchResultByEnter = getNextSearchResultByEnter;

		vm.columnNotRemove = 'fullName';
		function builHearingGridSetting() {
			vm.closeHearingGridSetting.push({ id: 'fullName', name: globalResources.Name, width: 35, coldefault: true });
			vm.closeHearingGridSetting.push({ id: 'countComment', name: globalResources.NumberOfComments, width: 15, coldefault: true });
			vm.closeHearingGridSetting.push({ id: 'response', name: globalResources.Assessment, width: 15, coldefault: true });
			vm.closeHearingGridSetting.push({ id: 'reason', name: globalResources.Appreciation, width: 35, coldefault: true });
		}
		function builHearingMemberGridSetting() {
			vm.hearingMemberGridSetting.push({ id: 'fullName', name: globalResources.Name, width: 70, coldefault: true });
			vm.hearingMemberGridSetting.push({ id: 'response', name: globalResources.Assessment, width: 30, coldefault: true });
		}

		function builPreHearingMembersGridSetting() {
			vm.preHearingMembersGridSetting.push({ id: 'fullName', name: globalResources.Name, width: 35, coldefault: true });
			vm.preHearingMembersGridSetting.push({ id: 'countComment', name: globalResources.NumberOfComments, width: 15, coldefault: true });
			vm.preHearingMembersGridSetting.push({ id: 'response', name: globalResources.Assessment, width: 15, coldefault: true });
			vm.preHearingMembersGridSetting.push({ id: 'reason', name: globalResources.Appreciation, width: 35, coldefault: true });
		}
		function builPreHearingMembersActiveGridSetting() {
			vm.preHearingMembersActiveGridSetting.push({ id: 'fullName', name: globalResources.Name, width: 70, coldefault: true });
			vm.preHearingMembersActiveGridSetting.push({ id: 'response', name: globalResources.Assessment, width: 30, coldefault: true });
		}

		vm.documentId = $stateParams.documentId;
		vm.contentAnchorPrefix = prefix.contentAnchorPrefix;
		vm.processRelationTypes = E.ProcessRelationType;
		vm.showError = false;
		vm.isFullScreen = true;
		vm.FolderLinks = [];

		vm.urlDocument = window.location.origin + '/document/' + vm.documentId;
		vm.updateFields = updateFields;
		vm.searchAndHighlightText = searchAndHighlightText;
		vm.navForward = navForward;
		vm.navBackward = navBackward;
		vm.fullScreen = fullScreen;
		vm.saveCommentDocument = saveCommentDocument;
		vm.saveCommentField = saveCommentField;
		vm.editCommentDocument = editCommentDocument;
		vm.editCommentField = editCommentField;
		vm.deleteCommentDocument = deleteCommentDocument;
		vm.deleteCommentField = deleteCommentField;
		vm.focusItem = focusItem;
		vm.postHearingResponse = postHearingResponse;
		vm.closeHearingFeedback = closeHearingFeedback;
		vm.activeTab = activeTab;
		vm.printPDF = printPDF;
		vm.openFileDocument = openFileDocument;
		vm.editCommentDraf = editCommentDraf;
		vm.addPerson = addPerson;
		vm.publishDocumentComment = publishDocumentComment;
		vm.publishFieldComment = publishFieldComment;
		vm.goToDocumentFields = goToDocumentFields;
		vm.openCompareDocument = openCompareDocument;
		vm.onTabSelectedDocument = onTabSelectedDocument;
		vm.documentCKVersion = CkVersion.CK4;
		vm.ckVersion = { 'CK4': CkVersion.CK4, 'CK5': CkVersion.CK5 };

		initialize();

		function initialize() {
			builHearingGridSetting();
			builHearingMemberGridSetting();
			builPreHearingMembersGridSetting();
			builPreHearingMembersActiveGridSetting();

			if (angular.element('#handbook-nav:visible').length == 0) {
				documentService.showFullscreen();
				vm.isFullScreen = false;
			}
			//Check and resize the view
			resizeService.resizeView();
			//Get current document and request for document if current is null
			getDocument();

			folderService.getFolderByVirtualDocumentId(vm.documentId).then(function (response) {
				vm.FolderLinks = response.data;
			});
		};

		function calculatorHeightContent(timeOut) {
			$timeout(function () {
				tabStateService.adjustContentHeightPosition(tabStateType.documentTabState);
			}, timeOut ? timeOut : 2000);
		}

		function onTabSelectedDocument() {
			calculatorHeightContent(500);
		}

		function getDocument() {
			vm.currentDataPromise =
				$http.get(handbookRequests.GetDocumentInformationForHearingRequest, { params: { 'documentId': $stateParams.documentId, showLoading: true } })
				.then(function (result) {
						if (result.data.hidden) {
							showMessageError(globalResources.NoAccessDocument, '632');
							return;
						}
						createTooltipsRelatedDocument(result.data);
						vm.currentData = result.data;
						vm.documentCKVersion = vm.currentData.isNewCKVersion;

						if (vm.currentData.description) {
							vm.currentData.description = $sce.trustAsHtml(vm.currentData.description.replace(new RegExp(String.fromCharCode(13) + String.fromCharCode(10), 'g'), '<br/>'));
						}
					vm.currentData.nodeType = convertToNodeType(vm.currentData.type);
						if (vm.currentData.fieldContents != null) {
							var indexTemp = 0;
							vm.currentData.fieldContents.forEach(function (fieldContent) {
								if (fieldContent.description) {
									fieldContent.description = $sce.trustAsHtml(fieldContent.description);
								}
								if (fieldContent.fieldType == E.DocumentFieldTypes.RichText && fieldContent.fieldContentId) {
									var params = {
										params: {
											id: fieldContent.fieldContentId,
											documentId: vm.documentId,
											hasExtention: vm.enableDocumentExtention,
											isHiddenContent: fieldContent.isHiddenContent
										}
									}
									$http.get('/api/documents/getRichTextViewDocument', params).then(function (response) {
										if (response.data && response.data.content) {
											fieldContent.content = documentService.changeUrlBackendToFrontend(window.location.origin, response.data.content, true);
											fieldContent.content = $sce.trustAsHtml(`${fieldContent.content} `);
											fieldContent.isVisible = true;
											fieldContent.fieldsAnchor = [];
											var aElement = document.createElement('div');
											aElement.innerHTML = response.data.content;
											var aTags = aElement.getElementsByTagName('a');
											if (aTags) {
												for (var i = 0; i < aTags.length; i++) {
													if (aTags[i].text.trim().length) {
														var itemAnchor = {
															value: aTags[i].text,
															id: aTags[i].name,
															name: aTags[i].id
														};
														fieldContent.fieldsAnchor.push(itemAnchor);
													}
												}
											};
										}
									});

								} else {
									if (fieldContent.content) {
										fieldContent.content = documentService.changeUrlBackendToFrontend(window.location.origin, fieldContent.content, true);
										fieldContent.content = $sce.trustAsHtml(`${fieldContent.content} `);
									}
								}
								fieldContent.indexShow = indexTemp;
								indexTemp = indexTemp + 1;
							});
							vm.updateFields();
						}

						runServicesAfterInit();

						documentService.setDocuments(null); // clear service

						getHearingData();

						calculatorHeightContent();
						updateAfterCurrentDataChanged();
						return vm.currentData;
					})
					.catch(function (result, status, headers, config) {
						showMessageError(result.data, result.status);
					});
		};

		function showMessageError(message, status) {
			if (!status || status.toString() == '600') {
				vm.errorMessage = globalResources.RequiredPermissionsToReadDocument;
			} else if (status.toString() == '632') {
				vm.errorMessage = globalResources.DocumentDoNotExistOrIsArchived;
			} else if (status.toString() == '633') {
				vm.errorMessage = globalResources.DocumentDoNotExistOrIsArchivedOrNotPublished;
				vm.showDocumentLinkToBackendWhenError = true;
			} else {
				vm.errorMessage = message;
			}
			vm.showError = true;
			vm.currentData.documentId = vm.documentId;

			runErrorServicesAfterInit();
		}


		function updateAfterCurrentDataChanged() {
			setIconForDocument(vm.currentData);
		}

		function setIconForDocument(data) {
			data = data == null ? vm.currentData : data;
			var icon = '';
			switch (data.levelType.toString()) {
				case E.HandbookLevelTypes.Enterprise:
					icon = paths.DocumentLevelTypeEnterprise;
					break;
				case E.HandbookLevelTypes.Regional:
					icon = paths.DocumentLevelTypeRegional;
					break;
				case E.HandbookLevelTypes.Local:
					icon = paths.DocumentLevelTypeLocal;
					break;
				default:
					icon = paths.DocumentLevelTypeEnterprise;
					break;
			}
			data.docIcon = icon;
		}

		function getHearingData() {
			$http.get(handbookRequests.GetHearingForFeedbackRequest, {
				params: {
					'entityId': vm.currentData.entityId
				}
			})
				.then(function (response, status, headers, config) {
					if (response.data && response.data.id != null && response.data.id > 0) {
						vm.hearing = response.data;

						if (vm.hearing.description && vm.hearing.description != '') {
							vm.hearing.description = $sce.trustAsHtml(vm.hearing.description.replace(/[\r\n\t]/g, "<br/>"));
						}

						checkMemberHearing();
						if (vm.currentData.approvalStatus == 3) {
							vm.showComment = (!vm.hearing.public && vm.isMemberHearing) || vm.hearing.public;
						} else {
							vm.showComment = false;
							vm.hearingClose = true;
						}
						if (vm.hearingClose) {
							vm.hearings = vm.hearing.hearingMembers;
							documentService.getHearingTooltip(vm.hearings);
							broadcastService(broadcastType.gridDataChanges, { id: 'closeHearing', data: vm.hearings, isForced: true });
						} else {
							vm.hearings = vm.hearing.hearingMembers;
						}

						var preHearingMembers = vm.hearing.preHearingMembers;
						documentService.getHearingTooltip(preHearingMembers);
						groupPreHearingMembers(preHearingMembers);

						if (!vm.hearingCommentAfterResponse && !vm.isMyAssessment) {
							vm.showComment = false;
						}
						adjustmentHearingComments(vm.hearing.hearingComments, vm.hearing.preHearingComments);
					}
					angular.copy(vm.currentData, vm.originalData);
					updateAfterCurrentDataChanged();
				});
		};

		function groupPreHearingMembers(preHearingMembers) {
			if (preHearingMembers == null || preHearingMembers.length <= 0)
				return;

			var result = groupBy(preHearingMembers, function (item) {
				return [item.hearingsId];
			});
			result = $filter('orderBy')(result, ['key']);

			for (var i = 0; i < result.length - 1; i++) {
				var order = 1;
				for (var j = i + 1; j < result.length; j++) {
					if (result[i].value.data[0].dueDate == result[j].value.data[0].dueDate) {
						result[i].order = !result[i].order ? order : result[i].order;
						result[j].order = order + 1;
						order = order + 1;
						if (j == result.length - 1)
							i = j;
					} else {
						i = j - 1;
						break;
					}
				}
			}
			vm.preHearingMembers = [];

			for (var i = 0; i < result.length; i++) {
				var membersGroup = result[i].value.data;
				membersGroup = $filter('orderBy')(membersGroup, ['fullName']);

				vm.preHearingMembers.push({
					members: membersGroup,
					name: membersGroup[0].dueDate + (result[i].order ? ' - ' + result[i].order : ''),
					href: 'preMemberTab' + result[i].key,
					icon: 'typcn typcn-message fa-lg',
					tabIndex: i,
					active: (i == 0)
				});
			}
		}

		function adjustmentHearingComments(dataComments, preDataComments) {
			var commentDocuments = [];
			var commentFields = [];
			if (dataComments.length > 0) {
				dataComments.forEach(function (item) {
					if (item.fieldId == null) {
						commentDocuments.push(angular.copy(item));
					} else {
						commentFields.push(angular.copy(item));
					}
				});
			}
			vm.commentDocuments = commentDocuments;

			var preCommentDocuments = [];
			var preCommentFields = [];
			if (preDataComments.length > 0) {
				preDataComments.forEach(function (item) {
					if (item.fieldId == null) {
						preCommentDocuments.push(angular.copy(item));
					} else {
						preCommentFields.push(angular.copy(item));
					}
				})
			}
			vm.preCommentDocuments = preCommentDocuments;

			if ((commentFields != null && commentFields.length > 0) || (preCommentFields != null && preCommentFields.length > 0)) {
				for (var i = 0; i < vm.currentData.fieldContents.length; i++) {
					var fieldContent = vm.currentData.fieldContents[i];
					fieldContent.commentDocumentText = '';
					if (commentFields != null && commentFields.length > 0) {
						var comments = [];
						commentFields.forEach(function (item) {
							if (fieldContent.fieldId == item.fieldId) {
								comments.push(angular.copy(item));
							}
						});
						fieldContent.comments = comments;
					}
					if (preCommentFields != null && preCommentFields.length > 0) {
						var preComments = [];
						preCommentFields.forEach(function (item) {
							if (fieldContent.fieldId == item.fieldId) {
								preComments.push(angular.copy(item));
							}
						});
						fieldContent.preComments = preComments;
					}
				}
			}
		};

		function editCommentDraf(comment) {
			comment.showCommentDocument = true;
			vm.focusItem('editCommentText' + comment.id);
			comment.commentDocumentText = comment.comment.replace(new RegExp('<br/>', 'g'), '\n');
		}

		function saveCommentDocument(isDraft) {
			var request = {
				entityId: vm.currentData.entityId,
				hearingsId: vm.hearing.id,
				comment: vm.commentDocumentText,
				isDraft: isDraft
			};
			$http.post(handbookRequests.CreateHearingCommentRequest, request)
				.success(function (data, status, headers, config) {
					vm.commentDocuments = data;
					vm.commentDocumentText = '';
				})
				.error(function (data, status, headers, config) {
					vm.hearingClose = true;
				});
		};

		function saveCommentField(fieldContent, isDraft) {
			var request = {
				entityId: vm.currentData.entityId,
				hearingsId: vm.hearing.id,
				comment: fieldContent.commentDocumentText,
				isDraft: isDraft,
				fieldId: fieldContent.fieldId
			};
			$http.post(handbookRequests.CreateHearingCommentRequest, request)
				.success(function (data, status, headers, config) {
					fieldContent.comments = data;
					fieldContent.commentDocumentText = '';
				})
				.error(function (data, status, headers, config) {
					vm.hearingClose = true;
				});
		};

		function publishDocumentComment(comment) {
			var request = {
				entityId: vm.currentData.entityId,
				hearingsId: vm.hearing.id,
				id: comment.id,
				comment: comment.comment
			};
			$http.post(handbookRequests.PublishHearingComment, request)
				.success(function (data, status, headers, config) {
					vm.commentDocuments = data;
					getHearingData();
				})
				.error(function (data, status, headers, config) {
					vm.hearingClose = true;
				});
		}

		function publishFieldComment(comment, fieldContent) {
			var request = {
				entityId: vm.currentData.entityId,
				id: comment.id,
				hearingsId: vm.hearing.id,
				fieldId: fieldContent.fieldId,
				comment: comment.comment
			};
			$http.post(handbookRequests.PublishHearingComment, request)
				.success(function (data, status, headers, config) {
					fieldContent.comments = data;
					getHearingData();
				})
				.error(function (data, status, headers, config) {
					vm.hearingClose = true;
				});
		}

		function editCommentDocument(comment, isDraft) {
			var request = {
				entityId: vm.currentData.entityId,
				hearingsId: vm.hearing.id,
				id: comment.id,
				comment: comment.commentDocumentText,
				isDraft: isDraft,
			};

			$http.post(handbookRequests.UpdateHearingCommentRequest, request)
				.success(function (data, status, headers, config) {
					vm.commentDocuments = data;
				})
				.error(function (data, status, headers, config) {
					vm.hearingClose = true;
				});
		};

		function editCommentField(comment, fieldContent, isDraft) {
			var request = {
				entityId: vm.currentData.entityId,
				id: comment.id,
				hearingsId: vm.hearing.id,
				comment: comment.commentDocumentText,
				isDraft: isDraft,
				fieldId: fieldContent.fieldId
			};
			$http.post(handbookRequests.UpdateHearingCommentRequest, request)
				.success(function (data, status, headers, config) {
					fieldContent.comments = data;
				})
				.error(function (data, status, headers, config) {
					vm.hearingClose = true;
				});
		};

		function deleteCommentDocument(comment) {
			var isConfirm = confirm(globalResources.DeleteHearingCommentConfirmMessage);
			if (isConfirm) {
				var request = {
					entityId: vm.currentData.entityId,
					id: comment.id
				};
				$http.post(handbookRequests.DeleteHearingCommentRequest, request)
					.success(function (data, status, headers, config) {
						vm.commentDocuments.splice($.inArray(comment, vm.commentDocuments), 1);
					})
					.error(function (data, status, headers, config) {
						vm.hearingClose = true;
					});
			}
		}

		function deleteCommentField(comment, comments) {
			var isConfirm = confirm(globalResources.DeleteHearingCommentConfirmMessage);
			if (isConfirm) {
				var request = {
					entityId: vm.currentData.entityId,
					id: comment.id
				};
				$http.post(handbookRequests.DeleteHearingCommentRequest, request)
					.success(function (data, status, headers, config) {
						comments.splice($.inArray(comment, comments), 1);
					})
					.error(function (data, status, headers, config) {
						vm.hearingClose = true;
					});
			}
		};

		function checkMemberHearing() {
			if (vm.hearing.hearingMembers.length > 0) {
				vm.hearing.hearingMembers.forEach(function (item) {
					if (item.employeeId == vm.loginUserId) {
						vm.isMyAssessment = !item.hearingResponse && vm.currentData.approvalStatus == 3;
						vm.isMemberHearing = true;
					}
				})
			}
		};

		function getPublishAndDraftCommentOfLoginUser() {
			vm.userLoginDraftComment = [];
			vm.userLoginPublishComment = [];

			vm.commentDocuments.forEach(function (item) {
				if (item.createdBy == vm.loginUserId) {
					if (item.isDraft) {
						vm.userLoginDraftComment.push(angular.copy(item));
					} else {
						vm.userLoginPublishComment.push(angular.copy(item));
					}
				}
			});

			for (var i = 0; i < vm.currentData.fieldContents.length; i++) {
				var fieldContent = vm.currentData.fieldContents[i];
				if (fieldContent.comments && fieldContent.comments.length > 0) {
					fieldContent.comments.forEach(function (item) {
						if (item.createdBy == vm.loginUserId) {
							if (item.isDraft) {
								vm.userLoginDraftComment.push(angular.copy(item));
							} else {
								vm.userLoginPublishComment.push(angular.copy(item));
							}
						}
					});
				}
			}
		};

		function postHearingResponse(message) {
			getPublishAndDraftCommentOfLoginUser();
			vm.responseFlag = message;
			if (vm.userLoginDraftComment.length > 0) {
				npDialog.showDialog(
					{
						type: dialogTypes.YES_NO,
						message: globalResources.ResponseConfirmDraftMessage,
						title: globalResources.HearingDocument,
						hearingEmailNotification: true
					}, processResponseWithDraftComment);
			} else {
				postResponse(false);
			}
		}

		function processResponseWithDraftComment(result) {
			var hasDraftComment = false;
			if (result == dialogResults.CONFIRM) {
				$http.post(handbookRequests.UpdatePublishAllCommentRequest, {
					entityId: vm.currentData.entityId,
					hearingsId: vm.hearing.id
				})
					.success(function (data, status, headers, config) {
						getHearingData();
						postResponse(false);
					})
					.error(function (data, status, headers, config) {
						vm.hearingClose = true;
					});
			} else {
				postResponse(true);
			}
		};

		function postResponse(hasDraftComment) {
			var countPushlishMessage = (vm.userLoginPublishComment.length != null ? vm.userLoginPublishComment.length : 0) + (hasDraftComment == false ? (vm.userLoginDraftComment.length != null ? vm.userLoginDraftComment.length : 0) : 0);
			var publishMessage = String.format(globalResources.PublishCommentToDocument, countPushlishMessage);
			var messageConfirm = '';
			switch (vm.responseFlag) {
				case RESPONSE_MESSAGE.recommended:
					messageConfirm = String.format(globalResources.ResponseRecommendedMessage, countPushlishMessage > 0 ? publishMessage : '');
					break;
				case RESPONSE_MESSAGE.notRecommended:
					messageConfirm = String.format(globalResources.ResponseNotRecommendedMessage, countPushlishMessage > 0 ? publishMessage : '');
					break;
				case RESPONSE_MESSAGE.neutral:
					messageConfirm = String.format(globalResources.ResponseNeutralMessage, countPushlishMessage > 0 ? publishMessage : '');
					break;
			}

			npDialog.showDialog(
				{
					type: dialogTypes.OK_CANCEL,
					message: messageConfirm,
					title: globalResources.HearingDocument,
					toggleReason: true,
					enableButton: vm.responseFlag == RESPONSE_MESSAGE.notRecommended,
					hearingEmailNotification: true
				}, processSendHearingResponse);
		}

		function processSendHearingResponse(result) {
			if (result.result == dialogResults.CONFIRM) {
				$http.post(handbookRequests.UpdateHearingResponseForMemberRequest, {
					entityId: vm.currentData.entityId,
					hearingsId: vm.hearing.id,
					hearingResponse: vm.responseFlag,
					reason: result.reason,
					emailNotification: result.emailNotification
				})
					.success(function (data, status, headers, config) {
						closeHearingFeedback();
					})
					.error(function (data, status, headers, config) {
						vm.hearingClose = true;
					});
			}
		}

		function focusItem(itemId) {
			setTimeout(function () {
				angular.element('#' + itemId).show();
				angular.element('#' + itemId).focus();
			}, 0);
		};

		function updateFields() {
			if (vm.currentData.relatedAttachments && vm.currentData.relatedAttachments.length > 0) {
				vm.currentData.relatedAttachments.forEach(function (x) {
					x.itemId = x.extraId ? x.extraId : x.itemId;
					x.isLastVersion = true;
				});
			}
			var relatedDocumentAll = angular.copy(vm.currentData.relatedDocuments);
			var relatedAttachmentAll = angular.copy(vm.currentData.relatedAttachments);
			var fieldContentsProcess = [];
			var fieldContentsNonProcess = [];

			vm.currentData.isShowTopBoxContent = false;

			for (var i = 0; i < vm.currentData.fieldContents.length; i++) {
				var fieldContent = vm.currentData.fieldContents[i];
				if (fieldContent.relatedAttachments && fieldContent.relatedAttachments.length > 0) {
					fieldContent.relatedAttachments.forEach(function (x) {
						x.itemId = x.extraId ? x.extraId : x.itemId;
					});
				}
				if (checkShowFieldName(fieldContent)) {
					vm.currentData.isShowTopBoxContent = true;
					if (fieldContent.isProcess) {
						fieldContentsProcess.push(fieldContent);
					}
					else {
						fieldContentsNonProcess.push(fieldContent);
					}
				}

				var relatedDocuments = fieldContent.relatedDocuments;
				relatedDocumentAll = relatedDocumentAll.concat(relatedDocuments);

				var relatedAttachments = fieldContent.relatedAttachments;
				relatedAttachmentAll = relatedAttachmentAll.concat(relatedAttachments);

				var relatedImageGroups = groupBy(fieldContent.images, function (item) {
					return [item.verticalAlign];
				});
				var relatedBottomImages = [];
				var relatedTopImages = [];
				relatedImageGroups.forEach(function (item) {
					if (item.key == parseInt(E.VerticalAlign.Top)) {
						relatedTopImages = relatedTopImages.concat(item.value.data);
					} else {
						if (item.key == parseInt(E.VerticalAlign.Bottom)) {
							relatedBottomImages = relatedBottomImages.concat(item.value.data);
						}
					}
				});
				fieldContent.relatedTopImages = relatedTopImages;
				fieldContent.relatedBottomImages = relatedBottomImages;
			}
			if (vm.currentData.isProcess) {
				vm.currentData.relatedDocumentAll = relatedDocumentAll;
				vm.currentData.relatedAttachmentAll = relatedAttachmentAll;

				vm.currentData.fieldContentsProcess = fieldContentsProcess;
				vm.currentData.fieldContentsNonProcess = fieldContentsNonProcess;

				var relatedDocumentGroups = groupBy(relatedDocumentAll, function (item) {
					return [item.folderId];
				});

				vm.currentData.relatedDocumentGroups = [];
				relatedDocumentGroups.forEach(function (item) {
					var relatedDocumentGroup = {};
					relatedDocumentGroup.id = item.key;
					relatedDocumentGroup.name = item.value.data[0].folderName;
					relatedDocumentGroup.relatedDocuments = item.value.data;
					vm.currentData.relatedDocumentGroups.push(relatedDocumentGroup);
				});

				relatedDocumentForDependencies(relatedDocumentAll);
				relatedAttachmentForDependencies(relatedAttachmentAll);
				attachRelatedItemsFieldsForDependencies();
			}
		};

		function attachRelatedItemsFieldsForDependencies() {
			vm.currentData.fieldContentsProcess.forEach(function (field) {
				var relatedDocumetFieldGroups = groupBy(field.relatedDocuments, function (item) {
					return [item.processRelationType];
				});
				var relatedDocumentInputValues = [];
				var relatedDocumentOutputValue = [];
				relatedDocumetFieldGroups.forEach(function (item) {
					if (item.key == parseInt(vm.processRelationTypes.InputOrInputValues)) {
						relatedDocumentInputValues = relatedDocumentInputValues.concat(item.value.data);
					} else {
						if (item.key == parseInt(vm.processRelationTypes.OutputOrOutputValues)) {
							relatedDocumentOutputValue = relatedDocumentOutputValue.concat(item.value.data);
						}
					}
				});
				field.relatedDocumentInputValues = relatedDocumentInputValues;
				field.relatedDocumentOutputValue = relatedDocumentOutputValue;

				var relatedAttachmentFieldGroups = groupBy(field.relatedAttachments, function (item) {
					return [item.processRelationType];
				});
				var relatedAttachmentInputValues = [];
				var relatedAttachmentOutputValue = [];
				relatedAttachmentFieldGroups.forEach(function (item) {
					if (item.key == parseInt(vm.processRelationTypes.InputOrInputValues)) {
						relatedAttachmentInputValues = relatedAttachmentInputValues.concat(item.value.data);
					} else {
						if (item.key == parseInt(vm.processRelationTypes.OutputOrOutputValues)) {
							relatedAttachmentOutputValue = relatedAttachmentOutputValue.concat(item.value.data);
						}
					}
				});
				field.relatedAttachmentInputValues = relatedAttachmentInputValues;
				field.relatedAttachmentOutputValue = relatedAttachmentOutputValue;
			});
		};

		function relatedDocumentForDependencies(relatedDocumentAll) {
			var relatedDocumentGroups = groupBy(relatedDocumentAll, function (item) {
				return [item.processRelationType];
			});
			var relatedDocumentManagements = [];
			var relatedDocumentResources = [];
			relatedDocumentGroups.forEach(function (item) {
				if (item.key == parseInt(vm.processRelationTypes.Management)) {
					relatedDocumentManagements = relatedDocumentManagements.concat(item.value.data);
				} else {
					if (item.key == parseInt(vm.processRelationTypes.Resources)) {
						relatedDocumentResources = relatedDocumentResources.concat(item.value.data);
					}
				}
			});

			vm.currentData.relatedDocumentManagement = relatedDocumentManagements;
			vm.currentData.relatedDocumentResources = relatedDocumentResources;
		};

		function relatedAttachmentForDependencies(relatedAttachmentAll) {
			var relatedAttachmentGroups = groupBy(relatedAttachmentAll, function (item) {
				return [item.processRelationType];
			});

			var relatedAttachmentManagements = [];
			var relatedAttachmentResources = [];
			relatedAttachmentGroups.forEach(function (item) {
				if (item.key == parseInt(vm.processRelationTypes.Management)) {
					relatedAttachmentManagements = relatedAttachmentManagements.concat(item.value.data);
				} else {
					if (item.key == parseInt(vm.processRelationTypes.Resources)) {
						relatedAttachmentResources = relatedAttachmentResources.concat(item.value.data);
					}
				}
			});
			vm.currentData.relatedAttachmentManagement = relatedAttachmentManagements;
			vm.currentData.relatedAttachmentResources = relatedAttachmentResources;
		};

		function searchAndHighlightText() {
			highlightTextInContent();
			documentContentsSearchService.searchAndHighlightText(vm.highlights);
		};

		function navForward() {
			documentContentsSearchService.navForward(vm.highlights);
		};

		function navBackward() {
			documentContentsSearchService.navBackward(vm.highlights);
		};

		function checkShowFieldName(fieldContent) {
			if (fieldContent.fieldName != '' && fieldContent.fieldName != undefined && fieldContent.isVisible && !fieldContent.isHideByBooklet) {
				return true;
			}
			return false;
		}

		function convertToNodeType(documentType) {
			switch (documentType.toString()) {
				case E.documentTypes.Document:
					return E.nodeTypes.Document;
				case E.documentTypes.LinkDocument:
					return E.nodeTypes.LinkDocument;
				case E.documentTypes.FileDocument:
					return E.nodeTypes.FileDocument;
				case E.documentTypes.ShortcutDocument:
					return E.nodeTypes.ShortcutDocument;
			}
		}

		function runServicesAfterInit() {
			$timeout(function () {
				updateLocalAnchors();
				scrollToAnchorIfExists();
			});
		}

		function runErrorServicesAfterInit() {
			tabStateService.closeOpenedTabIfNoPrivilege(tabStateType.documentTabState);
		}

		function scrollToAnchorIfExists() {
			var hash = $location.hash();
			if (hash != '') {
				$anchorScroll();
			}
		}

		function updateLocalAnchors() {
			var domContent = angular.element('div#document-content');
			anchorService.updateLocalAnchors(domContent);
		}

		function highlightTextInContent() {
			if (vm.currentData.fieldContents != undefined) {
				var viewMode = angular.copy(vm.currentData.viewMode);
				angular.copy(vm.originalData, vm.currentData);
				vm.currentData.viewMode = viewMode;
				vm.currentData.fieldContents.forEach(function (fieldContent) {
					fieldContent.content = documentContentsSearchService.searchAndHighlight(fieldContent.content, vm.highlights.highlightText);
					fieldContent.description = $sce.trustAsHtml(fieldContent.description.toString());
				});
			}
		};

		function fullScreen() {
			if (vm.isFullScreen) {
				documentService.showFullscreen();
			} else {
				documentService.showNormal();
			}
			vm.isFullScreen = !vm.isFullScreen;
		}

		$scope.$on(broadcastType.toggleDocumentFullscreen, function (e, target) {
			fullScreen();
		});

		function closeHearingFeedback() {
			window.close();
		};

		function activeTab() {
			$timeout(function () {
				tabStateService.adjustContentHeightPosition(tabStateType.documentTabState);
			}, 500);
		};

		function printPDF() {
			window.open(String.format("/Printing/PrintHearingFeedback?documentId={0}", vm.documentId));
		};

		function openFileDocument() {
			window.open(handbookRequests.GetFileDocumentRequest + vm.currentData.entityId, '_blank');
		}

		function addPerson() {
			var employees = [];
			vm.hearings.forEach(function (item) {
				employees.push({ id: item.employeeId });
			});
			var modalInstance = openAddMembersDialog($uibModal, employees, vm.translation.AddToHearingsPerson, null, true, vm.currentData.folderId, true);
			modalInstance.result.then(function (data) {
				onAddedMembers(data);
			});
		}

		function onAddedMembers(data) {
			if (!data) {
				return;
			}
			vm.members = [];
			data.forEach(function (item) {
				vm.members.push({
					fullName: item.fullName,
					email: item.email,
					departmentName: item.departmentName,
					id: item.id
				});
			});

			if (vm.members.length != 0) {
				var url = String.format('{0}/document/{1}/hearing', window.location.origin, vm.documentId);
				var objectEmailContent = {
					documentName: vm.currentData.documentName,
					documentResponsible: vm.currentData.responsible,
					url: url,
					dueDate: $filter('date')(vm.hearing.dueDate, "dd.MM.yyyy"),
					allowForwarding: vm.hearing.allowForwarding
				};
				var modalInstance = $uibModal.open({
					templateUrl: '/app/components/document/sendDocumentToHearingEmail.html',
					controller: 'SendDocumentToHearingEmailController as vm',
					size: 'md',
					resolve: {
						objectEmailContent: function () {
							return objectEmailContent;
						}
					}
				});

				modalInstance.result.then(function (data) {
					onSendEmail(data);
				});
			}
		}

		function onSendEmail(data) {
			if (!data) {
				return;
			}
			var request = {
				subject: data.subject,
				body: data.body,
				employees: vm.members,
				entityId: vm.currentData.entityId,
				documentId: vm.documentId,
				hearingId: vm.hearing.id
			};

			$http.post('/api/Documents/AddMembersToHearingDocument', request)
				.success(function (data, status, headers, config) {
					vm.hearings = data;
					broadcastService(broadcastType.gridDataChanges, { id: 'activeHearing', data: vm.hearings, isForced: true });
				})
				.error(function (data, status, headers, config) {
					if (status == httpStatusCodes.METHOD_NOT_ALLOWED) {
						vm.alerts.unshift({ type: 'danger', message: resources.M.Common.dontHaveActionPermission });
					}
					else {
						vm.alerts.unshift({ type: 'danger', message: getErrorMessage(status) });
					}
				});
		}

		function goToDocumentFields(fieldId) {
			$state.go('hearingFieldsContent', { documentId: vm.documentId, fieldId: fieldId });
		};

		function openCompareDocument() {
			window.open(String.format('/documenthearing/{0}/compareWithEarlierVersion', vm.currentData.documentId), '_blank');
		}

		function getNextSearchResultByEnter(keyEvent) {
			if (keyEvent.which == 13) {
				navForward();
			}
		}

	};

})();